module.exports = __webpack_public_path__ + "static/media/02 REGGIANA CALCIO Badia.7e66fd32.svg";